module.exports = __webpack_public_path__ + "static/essentialism-9a212cad82880f00231aa50e10f70687.jpg";